<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "TutorPanel"
    }
</script>

<style scoped>

</style>